<script setup lang="js">
const ModalTradingSetting = defineAsyncComponent(() => import('./modal/TradingSetting.vue'))
const show = ref(false)
</script>

<template>
  <div class="ms-auto">
    <button class="w-8 h-8 hover:bg-btnSecondary rounded-full flex items-center justify-center transition" @click="show = true">
      <svgo-futures-setting class="w-4 h-4 cursor-pointer text-textPrimary" />
    </button>

    <ModalTradingSetting v-model:show="show" />
  </div>
</template>
